import { useState } from "react";
import { TbPalette } from "react-icons/tb";
import { Modal } from "./Modal";
import { useTheme } from "../../context/ThemeContext";

export const ThemeSwatchGrid = ({ onSelect }) => {
  const { theme, setTheme, themeOptions } = useTheme();

  const selectTheme = (name) => {
    setTheme(name);
    onSelect?.(name);
  };

  return (
    <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3">
      {themeOptions.map((option) => (
        <button
          key={option.name}
          type="button"
          onClick={() => selectTheme(option.name)}
          aria-pressed={option.name === theme}
          className="flex flex-col gap-2 rounded-2xl border p-3 text-left transition"
          style={{
            borderColor: option.name === theme ? "var(--accent)" : "var(--card-border)",
            boxShadow: option.name === theme ? "0 0 0 3px var(--accent-tint)" : "none",
          }}
        >
          <span
            className="h-8 rounded-xl"
            style={{ background: `linear-gradient(135deg, ${option.swatchBg} 55%, ${option.swatchAccent} 55%)` }}
            aria-hidden="true"
          />
          <span className="text-xs font-semibold" style={{ color: "var(--foreground)" }}>{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export const ThemePicker = ({ compact = false }) => {
  const { theme, themeOptions } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const current = themeOptions.find((option) => option.name === theme) ?? themeOptions[0];

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className={`button-secondary inline-flex items-center justify-center gap-2 rounded-full text-sm font-medium transition ${compact ? "h-10 w-10 px-0 py-0" : "px-4 py-2"}`}
        aria-label={`Change theme (current: ${current.label})`}
        title={compact ? `Theme: ${current.label}` : undefined}
      >
        {compact ? (
          <span
            className="h-4 w-4 rounded-full border border-current/20"
            style={{ background: current.swatchAccent }}
            aria-hidden="true"
          />
        ) : (
          <TbPalette className="h-4 w-4" aria-hidden="true" />
        )}
        {compact ? null : `Theme: ${current.label}`}
      </button>

      <Modal isOpen={isOpen} title="Theme" description="Ink & Signal — pick a colorway." onClose={() => setIsOpen(false)}>
        <ThemeSwatchGrid onSelect={() => setIsOpen(false)} />
      </Modal>
    </>
  );
};

export default ThemePicker;
